// List cars colors from api
import React, { useState } from 'react';
// import axios from 'axios';
// import { serverURL } from '../helpers/dataServerURL';
import styles from '../css/carsColors.module.css';
import { useNavigate } from 'react-router-dom';

export default function CarsColors({ closeScreen }) {
  // const [colors, setColors] = useState(
  //   []
  // );
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const topColors = [
    'Blue',
    'SkyBlue',
    'ForestGreen',
    'Green',
    'White',
    'Black',
    'Yellow',
    'Silver',
    'Gray',
    'Tan',
    'Red',
    'Brown',
  ];
  const colorsHex = [
    '#0000FF',
    '#87CEEB',
    '#228B22',
    '#008000',
    '#ffffff',
    '#000000',
    '#ffff00',
    '#c0c0c0',
    '#808080',
    '#d2b48c',
    '#ff0000',
    '#8b4513',
  ];
  const fontColors = [
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#000000',
    '#000000',
    '#ffffff',
    '#000000',
    '#ffffff',
    '#ffffff',
  ];
  // const [loading, setLoading] =
  //   useState(true);
  // const loginURL = serverURL.server.url;

  // useEffect(() => {
  //   fetchColors();
  // });

  // async function fetchColors() {
  //   try {
  //     const response = await axios.get(
  //       `${loginURL}/carsColors/topColors`
  //     );

  //     if (response.data) {
  //       setColors(response.data);
  //     }
  //     console.log(
  //       'Colors fetched successfully:',
  //       response.data,
  //       colors
  //     );
  //   } catch (error) {
  //     console.error(
  //       'Error fetching colors:',
  //       error
  //     );
  //   }
  // }

  return (
    <div>
      <div>
        <h2
          style={{
            color: '#000000',
            marginTop: '20px',
            marginBottom: '10px',
            textAlign: 'center',
          }}
        >
          Select Car Color
        </h2>
      </div>
      <div className={styles.colorsContainer}>
        {topColors.map((color, index) => (
          <button
            key={color}
            style={{
              backgroundColor: isHovered === false ? colorsHex[index] : colorsHex[index] + 'cc',
              color: fontColors[index],
            }}
            className={styles.colorBtn}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => {
              navigate('/ticketEntry', {
                state: {
                  selectedCarColor: color,
                },
              });
              closeScreen();
            }}
          >
            {color}
          </button>
        ))}
      </div>
    </div>
  );
}
